import { queryOptions, useQuery } from '@tanstack/react-query';

const QUERY_KEY = ['tax-identification-number', 'formats'];

const loadTaxIdentificationNumberFormats = async () => {
  const { TIN_COVERAGE_BY_COUNTRY, TIN_PLACEHOLDER_BY_COUNTRY, validateTin } = await import('@1trading/ts-common/tin');

  return { coverage: TIN_COVERAGE_BY_COUNTRY, examples: TIN_PLACEHOLDER_BY_COUNTRY, validate: validateTin };
};

export const taxIdentificationNumberFormatsQueryOptions = queryOptions({
  gcTime: Number.POSITIVE_INFINITY,
  staleTime: Number.POSITIVE_INFINITY,
  queryFn: loadTaxIdentificationNumberFormats,
  queryKey: QUERY_KEY,
  // The cached value holds a function, which structural sharing would not round-trip.
  structuralSharing: false,
});

export const useTaxIdentificationNumberFormats = () => useQuery(taxIdentificationNumberFormatsQueryOptions);
